import api from "../../services/axiosConfig"; // adjust path as needed if it differs

export const fetchHdfsList = async (path = "/") => {
  try {
    const response = await api.post(
      "/instances/big-data/hdfs/list-fs",
      { path },
      { headers: { Accept: "application/json" } },
    );
    return response.data.files || [];
  } catch (error) {
    console.error("Error fetching HDFS list:", error);
    throw error;
  }
};

export const createHdfsDirectory = async (data) => {
  try {
    const response = await api.post(
      "/instances/big-data/hdfs/create-directory",
      {
        directory: data.directory,
        path: data.path,
        recursive: data.recursive ? "true" : "false",
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error creating directory:", error);
    throw error;
  }
};

export const deleteHdfsDirectory = async (data) => {
  try {
    const response = await api.delete(
      "/instances/big-data/hdfs/delete-directory",
      {
        data: {
          path: data.path,
          force: data.force,
        },
        headers: { "Content-Type": "application/json" },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting directory:", error);
    throw error;
  }
};

export const uploadHdfsFile = async (data) => {
  try {
    const formData = new FormData();
    formData.append("hdfsPath", data.hdfsPath);
    formData.append("filename", data.filename);
    formData.append("file", data.file);

    const response = await api.post(
      "/instances/big-data/hdfs/upload-file",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 600000,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};
